import Gamer from "./Gamer"

class BankerGamer extends Gamer {

}

export default BankerGamer
